const SvgSecurity3 = (props) => (
  <>
    <defs />
    <path
      d="M192 0v384M336 152 192 80M336.74 232.37 192 160M320.01 304 192 240M270.76 359.38 192 320"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cx={192} cy={80} r={8} fill="#1e62f5" strokeWidth={0} />
    <circle cx={192} cy={80} r={24} stroke="#021d6c" fill="none" strokeMiterlimit={10} />
    <circle cx={192} cy={240} r={8} fill="#1e62f5" strokeWidth={0} />
    <circle cx={192} cy={240} r={24} stroke="#021d6c" fill="none" strokeMiterlimit={10} />
    <path
      d="M192 0 48 72v160.68C48 315.9 112.8 384 192 384s144-68.09 144-151.32V72L192 0"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
  </>
);

export default SvgSecurity3;
